import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Bulletin } from "../types";

export const getBulletinList = async (): Promise<Bulletin[]> => {
  const collectionRef = collection(db, "bulletins");

  const q = query(collectionRef, orderBy("isHighPriority", "desc"));

  const bulletinSnapshot = await getDocs(q);

  return bulletinSnapshot.docs.map((doc) => {
    const data = doc.data() as Bulletin;

    return {
      ...data,
      id: doc.id,
    } as Bulletin;
  });
};
